export default __webpack_public_path__ + "static/media/kolectiv-2021-front.40fce168.png";